/** "48s", "3m 12s", "1h 02m" — the scale a reader thinks in for a pipeline. */
export function formatDuration(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${String(s % 60).padStart(2, '0')}s`;
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`;
}

const ABSOLUTE = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * When a run started: relative within a day ("14 min ago"), a date and time
 * after that ("28 Aug, 08:57"), and the exact moment for a hover.
 *
 * Relative first because the history is read for recency — "is this the run I
 * just pushed?" — and seconds on a timestamp answer nothing a reader asks.
 */
export function formatStarted(
  iso: string | null,
  now: number,
): { label: string; exact: string } | undefined {
  if (!iso) return undefined;
  const at = new Date(iso);
  const t = at.getTime();
  if (!Number.isFinite(t)) return undefined;
  const exact = at.toLocaleString();
  const ms = now - t;
  if (ms < 60_000) return { label: 'just now', exact };
  if (ms < 3_600_000) {
    return { label: `${Math.floor(ms / 60_000)} min ago`, exact };
  }
  if (ms < 86_400_000) {
    return { label: `${Math.floor(ms / 3_600_000)} h ago`, exact };
  }
  return { label: ABSOLUTE.format(at), exact };
}
